export default {
  root: {
    minWidth: 700,
    cursor: 'pointer',
  },
};
